<template>
    <div class="container">
        <label class="title">{{title}}</label>
        <label class="subtitle discount" v-if="discount">-{{subtitle}} {{currency}}</label>
        <label class="subtitle" v-else>{{subtitle}} {{currency}}</label>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    title: {
    },
    subtitle: {
    },
    discount: {
      default: false
    }
  },
  computed: {
    ...mapState({
      currency: state => state.currency.currency
    })
  }
}
</script>
<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
  }
  .title {
    width: 7rem;
    font-size: 0.7rem;
    color: #333;
    margin-right: 0.85rem;
  }
  .subtitle {
    flex: 1;
    margin-right: 1rem;
    margin-left: 0.75rem;
    color: $primaryColor;
    font-size: 0.75rem;
    text-align: left;
  }
  .subtitle.discount{
    color:#333
  }
</style>
